var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.title && _vm.body
    ? _c(
        "div",
        { attrs: { id: "client-message-page" } },
        [
          _c("checkout-header", {
            attrs: {
              categoryFilter: { display: false },
              shoppingBag: { display: false },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-center",
              attrs: { id: "message-container" },
            },
            [
              _c("error-state-icon", { attrs: { iconType: _vm.iconToShow } }),
              _vm._v(" "),
              _c(
                "h2",
                { staticClass: "bold", attrs: { id: "message-title" } },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _vm._v(" "),
              _c("p", { attrs: { id: "message-body" } }, [
                _vm._v(_vm._s(_vm.body)),
              ]),
              _vm._v(" "),
              _vm.content &&
              _vm.content.clientMessages[_vm.clientMessageKey].button_text
                ? _c("v-button", {
                    attrs: {
                      position: "center",
                      mobile: "12",
                      tablet: "12",
                      desktop: "12",
                      styling: "primary",
                      textAlign: "center",
                      disabled: false,
                    },
                    on: {
                      onClickEvent: function ($event) {
                        return _vm.navigateOut()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.buttonText) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      369914089
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }